const getGuideDownloadPopupUrl = (trigger) => {
  const configuredUrl = trigger.dataset.guideDownloadUrl;

  if (!configuredUrl) {
    return null;
  }

  try {
    const url = new URL(configuredUrl, window.location.href);

    if (
      url.origin === window.location.origin
      && /\/guide-download\/[^/]+\/popup\/?$/.test(url.pathname)
    ) {
      return url.href;
    }
  } catch {}

  return null;
};

if (!window.__guideDownloadPopupBound) {
  window.__guideDownloadPopupBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-guide-download-trigger]');
    const url = trigger ? getGuideDownloadPopupUrl(trigger) : null;

    if (!trigger || !url || typeof window.load !== 'function') {
      return;
    }

    event.preventDefault();
    window.load(url);
  });
}

const guideDownloadPopupScrollListeners = new WeakSet();

const initGuideDownloadPopupScroll = (scope = document) => {
  const root = typeof scope === 'string' ? document.querySelector(scope) : scope;

  if (!root || typeof window.SimpleBar !== 'function') {
    return;
  }

  const content = root.querySelector('.guide-download-popup .popup__content');

  if (!content) {
    return;
  }

  const existingInstance = window.SimpleBar.instances?.get(content);
  const instance = existingInstance ?? new window.SimpleBar(content, {
    autoHide: false,
  });

  if (existingInstance) {
    instance.recalculate();
  }

  const scrollElement = instance.getScrollElement?.()
    ?? content.querySelector('.simplebar-content-wrapper');

  if (!scrollElement || guideDownloadPopupScrollListeners.has(scrollElement)) {
    return;
  }

  guideDownloadPopupScrollListeners.add(scrollElement);
  scrollElement.addEventListener('scroll', () => {
    window.dispatchEvent(new Event('scroll'));
  }, { passive: true });
};

window.initGuideDownloadPopupScroll = initGuideDownloadPopupScroll;

let guideDownloadStickyFrame = null;

const updateGuideDownloadStickyVisibility = () => {
  guideDownloadStickyFrame = null;

  const stickies = document.querySelectorAll('.guide-download-sticky');
  const firstSection = document.querySelector('.first-sec');
  const footer = document.querySelector('.footer');
  const firstSectionRect = firstSection?.getBoundingClientRect() ?? null;
  const footerRect = window.innerWidth <= 1100
    ? footer?.getBoundingClientRect() ?? null
    : null;

  stickies.forEach((sticky) => {
    const stickyRect = sticky.getBoundingClientRect();
    const overlapsFirstSection = firstSectionRect
      && stickyRect.top < firstSectionRect.bottom
      && stickyRect.bottom > firstSectionRect.top
      && stickyRect.left < firstSectionRect.right
      && stickyRect.right > firstSectionRect.left;
    const overlapsFooter = footerRect
      && stickyRect.top < footerRect.bottom
      && stickyRect.bottom > footerRect.top
      && stickyRect.left < footerRect.right
      && stickyRect.right > footerRect.left;

    sticky.classList.toggle(
      'is-hero-overlap',
      window.innerWidth <= 1480 && Boolean(overlapsFirstSection),
    );
    sticky.classList.toggle('is-footer-overlap', Boolean(overlapsFooter));
    sticky.classList.toggle(
      'is-outside-first-section',
      !firstSectionRect || !overlapsFirstSection,
    );
    sticky.classList.add('is-ready');
  });
};

const scheduleGuideDownloadStickyVisibility = () => {
  if (guideDownloadStickyFrame !== null) {
    return;
  }

  guideDownloadStickyFrame = window.requestAnimationFrame(
    updateGuideDownloadStickyVisibility,
  );
};

const initGuideDownloadSticky = () => {
  if (!document.querySelector('.guide-download-sticky')) {
    return;
  }

  scheduleGuideDownloadStickyVisibility();

  if (window.__guideDownloadStickyVisibilityBound) {
    return;
  }

  window.__guideDownloadStickyVisibilityBound = true;
  window.addEventListener('scroll', scheduleGuideDownloadStickyVisibility, {
    passive: true,
  });
  window.addEventListener('resize', scheduleGuideDownloadStickyVisibility);
};

initGuideDownloadSticky();
window.initGuideDownloadSticky = initGuideDownloadSticky;
